import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { LoginService } from '../providers/login.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ScriptService } from '../providers/script.service';
import { isPlatformBrowser } from '@angular/common';
import { DialogStateService } from '../providers/dialog-state.service';
import { AppService } from '../providers/app.service'

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'iquanta';
  cookieValue: any;
  showEnquiryBtn: boolean = true;
  currentPageUrl: boolean = false;
  userData: any;
  token: any;
  url: any;
  iconsDisplay: boolean = false;
  showCoursePackages: boolean = false;

  constructor(public dialog: MatDialog, @Inject(DOCUMENT) public doc: Document, public matSnackBar: MatSnackBar,
    @Inject(LOCAL_STORAGE) public sessionStorage: any, public router: Router, public loginService: LoginService,
    public deviceService: DeviceDetectorService, @Inject(DOCUMENT) public document: any, public dashboardService: AppService,
    public formBuilder: FormBuilder, public coursesService: AppService,
    public elementRef: ElementRef, private renderer: Renderer2, public scriptService: ScriptService,
    private renderer2: Renderer2, @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private _document: any, private dialogState: DialogStateService) {

  }

  gotoCourses() {
    var elemnt: any = document.getElementById('courses-div')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }

  dialogStatus() {
    this.dialogState.dialogOpen.subscribe(res => {
      if (res == 'false' || !res) {

        this.openLeadForm()

      }
    })
  }

  loadUserSpecificScripts(scriptUrl: string[]) {
    scriptUrl.map((url) => {
      const htmlScriptElement = document.createElement('script');
      htmlScriptElement.src = url;
      htmlScriptElement.async = true;
      this.elementRef.nativeElement.appendChild(htmlScriptElement);
    })

  }

  private redirected = false;

  ngOnInit() {
    this.callBackForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      year: ['', Validators.required],
      course: ['']
    })


    this.url = document.URL.split('/')[document.URL.split('/').length - 1];

    if (this.document.URL.includes('utm_source') || this.document.URL.includes('utm_medium') || this.document.URL.includes('utm_campaign')) {
      this.sessionStorage.setItem('utmLink', this.document.URL.split('?')[1])
    }
    this.getAddressIP()

    // this.gtmService.loadGTM('AW-10805359252')

    if (
      document.URL == 'https://www.iquanta.in/?utm_source=paid&utm_medium=traffic&utm_campaign=cat+2025' ||
      document.URL == 'https://www.iquanta.in/cat-2025?utm_source=paid&utm_medium=leads&utm_campaign=cat+add+ons' ||
      document.URL == 'https://www.iquanta.in/details/iim-abc-practice-batch?utm_source=Facebook&utm_medium=paid&utm_campaign=CAT-IIMABC-TRAFFIC-CAMPAIGN' ||
      document.URL == 'https://www.iquanta.in/best-cat-books?utm_source=Facebook&utm_medium=paid&utm_campaign=CAT-BOOKS-TRAFFIC-CAMPAIGN' ||
      document.URL == 'https://www.iquanta.in/details/icat-mock-test-series?utm_source=Facebook&utm_medium=paid&utm_campaign=CAT-MOCKS-TRAFFIC-CAMPAIGN') {
      $('#ChooseEquiry1').modal('show');
    }

    // this.openLeadForm()


    // Check if user came from external site
    const fromExternal = document.referrer && !document.referrer.includes(window.location.hostname);

    if (fromExternal) {
      // Push a fake state into browser history
      history.pushState(null, '', window.location.href);

      window.addEventListener('popstate', () => {
        if (!this.redirected) {
          this.redirected = true;
          this.router.navigateByUrl('/');
        }
      });
    }

    //  if(this.document.URL.includes('new-home')){
    //   this.dialogStatus()
    // }

    if (this.document.URL == 'https://www.iquanta.in/' || this.document.URL == 'https://iquanta.in/' || this.document.URL.includes('cat') || this.document.URL.includes('mba')
      || this.document.URL.includes('iim') || this.document.URL.includes('/?') && !this.document.URL.includes('cat-mock-test')) {
      if (isPlatformBrowser(this.platformId)) {
        if (!this.sessionStorage.getItem('usertoken')) {
          this.dialogStatus()
        }
      }
    }



  }

  setTidioVisibility(visible: boolean) {
    const tidioIframe = document.querySelector('iframe[src*="tidio"]') as HTMLIFrameElement;
     console.log('asdasdasdas')
    if (tidioIframe) {
      tidioIframe.style.display = visible ? 'block' : 'none';
    }

    // Also try hiding the main container if present
    const tidioContainer = document.getElementById('tidio-chat');
    if (tidioContainer) {
      tidioContainer.style.display = visible ? 'block' : 'none';
    }
  }

  timeoutId: any;

  @HostListener('window:beforeunload', ['$event'])
  @HostListener('window:unload', ['$event']) // Optional, for more reliability
  onWindowUnload(event: Event): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      //console.log('Timeout cleared on tab close');
    }
  }



  openLeadForm() {
    // console.log(this.dialog.openDialogs.length)
    setTimeout(() => {
      if (this.dialog.openDialogs.length === 0 && !this.sessionStorage.getItem('leadObj')) {
        if (this.document.URL == 'https://www.iquanta.in/' || this.document.URL == 'https://iquanta.in/' || this.document.URL.includes('cat') || this.document.URL.includes('mba')
          || this.document.URL.includes('iim') || (this.document.URL.includes('/?'))) {
          this.setTidioVisibility(false)
          const dialog = this.dialog.open(LeadFormDialog, {
            panelClass: 'leadForm',
            width: '100%',
            backdropClass: 'custom-backdrop-width'
          })
          dialog.afterClosed().subscribe(res => {
            this.setTidioVisibility(true)

            if (res) {
              this.sessionStorage.setItem('dialogLeadSubmit', 'true')
            } else {
              this.timeoutId = setTimeout(() => {
                let leadData: any = this.sessionStorage.getItem('leadObj');
                let data: any
                if (leadData) {
                  data = JSON.parse(leadData)
                  if (!data.step4) {
                    if (this.document.URL == 'https://www.iquanta.in/' || this.document.URL == 'https://iquanta.in/' || this.document.URL.includes('cat') || this.document.URL.includes('mba')
                      || this.document.URL.includes('iim') || this.document.URL.includes('/?')) {
                      this.dialogStatus(); // Reopen after 3 mins
                    }
                  }
                } else {
                  if (this.document.URL == 'https://www.iquanta.in/' || this.document.URL == 'https://iquanta.in/' || this.document.URL.includes('cat') || this.document.URL.includes('mba')
                    || this.document.URL.includes('iim') || this.document.URL.includes('/?')) {
                    this.dialogStatus(); // Reopen after 3 mins
                  }
                }

              }, 3 * 60 * 1000);
            }
          })
        }
      }
    }, 30000)
  }

  submittedBtn: boolean = false;
  addNPF() {
    let medium: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.callBackForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.callBackForm.value.phone,
      "email": this.callBackForm.value.email,
      "field_gender": '',
      "field_exam_category": this.callBackForm.value.course,
      "field_exam": this.callBackForm.value.course,
      "field_course_year": this.callBackForm.value.year,
      "source": "Website " + medium,
      "medium": "Call Back Form",
      "field_lead_priority": 'Gold',
      "field_page_location": this.sessionStorage.getItem('utmLink') ? this.doc.URL + '?' + this.sessionStorage.getItem('utmLink') : this.doc.URL
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      if (res.message == "Mobile number already exists." || res.status == 'Successfully updated') {
        let reqData = {
          "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
          "college_id": "5802",
          "user_id": res.data.user_id,
          "name": this.callBackForm.value.name,
          "field_last_name": '',
          "country_dial_code": "+91",
          "mobile": this.callBackForm.value.phone,
          "email": this.callBackForm.value.email,
          "field_gender": '',
          "field_exam_category": "",
          "field_exam": this.callBackForm.value.course,
          "field_course_year": '',
          "source": "Website " + medium,
          "medium": "Call Back Form",
          "field_lead_priority": 'Gold',
          "field_reinquire": 'Yes',
          "field_page_location": this.sessionStorage.getItem('utmLink') ? this.doc.URL + '?' + this.sessionStorage.getItem('utmLink') : this.doc.URL

        }
        this.dashboardService.updateLeadSquared(reqData).subscribe((res: any) => {
          if (res) {
            this.callBackForm.reset()
          }
        })
      } else {
        this.callBackForm.reset()
      }
    })
  }
  courseEnquiry() {
    if (this.callBackForm.valid) {
      this.submittedBtn = true;
      let reqObj = {
        name: this.callBackForm.value.name,
        email: this.callBackForm.value.email,
        phone_no: this.callBackForm.value.phone,
        course_name: this.callBackForm.value.course,
        year: this.callBackForm.value.year,
        page_location: this.sessionStorage.getItem('utmLink') ? this.doc.URL + '?' + this.sessionStorage.getItem('utmLink') : this.doc.URL
      }
      this.coursesService.callback(reqObj).subscribe(res => {
        // this.dialogRef.close(res)
        if (res.success) {
          this.getExamCategory1()
          this.addNPF()
          $('#ChooseEquiry1').modal('hide');
          this.sendEventToGTM()

          $("#ThanksModal").modal('show')

        }
      })
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }
  }

  closeThanks() {
    $("#ThanksModal").modal('hide');
    location.reload()
  }

  sendEventToGTM() {
    const s = this.renderer2.createElement('script');
    s.text = `window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event' : 'form_submission_success',
  })`;
    this.renderer2.appendChild(this._document.body, s);
  }

  selectedCategory: any[] = []
  selectedExams: any[] = []
  selectedExams1: any[] = []
  selectedExams2: any[] = []
  selectedExams3: any[] = []
  selectedExams4: any[] = []
  getExamCategory1() {
    this.callBackForm.value.course.forEach((course: any) => {
      if (this.examList.includes(course)) {
        if (!this.selectedCategory.includes('MBA')) {
          this.selectedCategory.push('MBA')
        }
        this.selectedExams.push(course)
      } else if (this.examList1.includes(course)) {
        if (!this.selectedCategory.includes('After 12th')) {
          this.selectedCategory.push('After 12th')
        }
        this.selectedExams1.push(course)
      } else if (this.examList2.includes(course)) {
        if (!this.selectedCategory.includes('Engineering')) {
          this.selectedCategory.push('Engineering')
        }
        this.selectedExams2.push(course)
      } else if (this.examList4.includes(course)) {
        if (!this.selectedCategory.includes('Study Abroad')) {
          this.selectedCategory.push('Study Abroad')
        }
        this.selectedExams4.push(course)
      }
      else {
        if (!this.selectedCategory.includes('Medical')) {
          this.selectedCategory.push('Medical')
        }
        this.selectedExams3.push(course)
      }
    })
    this.addInternalCRMLead('Course Enquiry')
  }

  addInternalCRMLead(type: any) {
    this.selectedCategory.forEach((cat: any) => {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "orgId": this.doc.URL.includes('/offline-center/jamshedpur') ? "68380db410fb67f12376090d" : "66dec57ce200bc89284602d6",
        "uid": this.doc.URL.includes('/offline-center/jamshedpur') ? "68380db510fb67f123760933" : '66dec57ce200bc89284602d6',
        "userId": this.userData ? this.userData.id : 9999,
        "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
        "name": this.callBackForm.value.name,
        "firstName": this.callBackForm.value.name,
        "countryCode": 91,
        "phone": this.callBackForm.value.phone,
        "email": this.callBackForm.value.email,
        "source": "Website",
        "medium": type == 'Course Enquiry' ? "Free Counselling" : "Whatsapp Message",
        "campaign": type,
        "pageLocation": this.doc.URL,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.doc.URL,
        "registrationDevice": this.deviceService.deviceType,
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        "customFields": {
          "exam": cat == 'MBA' ? this.selectedExams.join(',') : cat == 'Engineering' ? this.selectedExams2.join(',') : cat == 'Medical' ? this.selectedExams3.join(',') : cat == 'Study Abroad' ? this.selectedExams4.join(',') : this.selectedExams1.join(','),
          "examCategory": cat,
          "leadPriority": "Platinum",
          "examTargetYear": type == 'Course Enquiry' ? this.callBackForm.value.year : 2025
        },
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "source": "Website",
            "medium": type == 'Course Enquiry' ? "Free Counselling" : "Whatsapp Message",
            "campaign": type,
            adContent: "",
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "pageLocation": this.doc.URL,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
          },
        ],

      }
      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
        }
      })
    })
  }

  changeBackdrop() {
    // $('#ChooseEquiry1').on('show.bs.modal', function () {
    //   setTimeout(function () {
    //     $('.modal-backdrop').addClass('custom-backdrop');
    //   }, 10);
    // });
  }

  ipAddress: any;
  getAddressIP() {
    this.loginService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
      this.sessionStorage.setItem('ipAddress', this.ipAddress)
    });
  }
  examList: any[] = ['CAT', 'XAT', 'CMAT', 'MICAT']
  examList1: any[] = ['CUET UG', 'CUET PG', 'IPMAT', 'CLAT']
  examList2: any[] = ['JEE Main', 'JEE Advance', 'BITSAT']
  examList3: any[] = ['NEET']
  examList4: any[] = ['GMAT', 'SAT', 'IELTS', 'GRE']


  callBackForm!: FormGroup;
  selectCat(val: any) {
    if (this.callBackForm.value.course.includes(val)) {
      this.callBackForm.value.course.splice(this.callBackForm.value.course.indexOf(val), 1)
    } else {
      let list: any[] = [];
      if (this.callBackForm.value.course) {
        list = this.callBackForm.value.course;

      }
      list.push(val)
      this.callBackForm.controls['course'].setValue(list)
    }
  }

  openwhatsup() {
    window.open('https://chat.whatsapp.com/HUMpkaccVmmEhYn8bvczet', '_blank')
    if (this.sessionStorage.getItem('userData')) {
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
    }
  }



  onActivate(ev: any) {
    if (this.doc.URL.includes('dashboard') || this.doc.URL.includes('online-cat') || this.doc.URL.includes('thanks') || this.doc.URL.includes('after12')
      || this.doc.URL.includes('cat-2023') || this.doc.URL.includes('patna') || this.doc.URL.includes('jaipur') ||
      this.doc.URL.includes('cuet') || this.doc.URL.includes('ipmat') || this.doc.URL.includes('istar') || this.doc.URL.includes('iit-jee-coaching') || this.doc.URL.includes('upsc-coaching') ||
      this.doc.URL.includes('cat-offline-coaching') || this.doc.URL.includes('iskills') || this.doc.URL.includes('tech') || this.doc.URL.includes('productmanagement')
      || this.doc.URL.includes('sop-for-iim') || this.doc.URL.includes('cat-score-vs-percentile-tool') || this.doc.URL.includes('cat-score-calculator') || this.doc.URL.includes('gdpi-course') || this.doc.URL.includes('isb-application')
      || this.doc.URL.includes('cat-results') || this.doc.URL.includes('neet') || this.doc.URL.includes('iim') || this.doc.URL.includes('cat-scholarship-test') || this.doc.URL.includes('new-home')
      || this.doc.URL.includes('jee-coaching-hamirpur') || this.doc.URL.includes('cat-preparation') || this.doc.URL.includes('cat-roadmap') || this.doc.URL.includes('cat-mock-test')) {
      this.currentPageUrl = false;
    } else {
      this.currentPageUrl = true;
    }
    if (this.doc.URL.includes('istar') || this.doc.URL.includes('cat-offline-coaching') || this.doc.URL.includes('iskills') || this.doc.URL.includes('tech') || this.doc.URL.includes('productmanagement')
      || this.doc.URL.includes('dashboard') || this.doc.URL.includes('iit-jee-coaching') || this.doc.URL.includes('upsc-coaching') || this.doc.URL.includes('sop-for-iim') || this.doc.URL.includes('cat-score-calculator')
      || this.doc.URL.includes('cat-score-vs-percentile-tool') || this.doc.URL.includes('gdpi-course') || this.doc.URL.includes('isb-application') || this.doc.URL.includes('upsc-coaching')
      || this.doc.URL.includes('iim') || this.doc.URL.includes('cat-scholarship-test') || this.doc.URL.includes('new-home') || this.doc.URL.includes('jee-coaching-hamirpur')) {
      this.iconsDisplay = false
    } else {
      this.iconsDisplay = true
    }
    if (this.doc.URL.includes('iim-calls') || this.doc.URL.includes('iskills') || this.doc.URL.includes('iit-jee-coaching') || this.doc.URL.includes('upsc-coaching')
      || this.doc.URL.includes('details') || this.doc.URL.includes('details') || this.doc.URL.includes('cat-scholarship-test') || this.doc.URL.includes('new-home')
      || this.doc.URL.includes('jee-coaching-hamirpur') || this.doc.URL == 'https://www.iquanta.in/' || this.doc.URL == 'http://192.168.4.74:4200/'
      || this.doc.URL == 'https://iquanta.in/' || this.doc.URL.includes('cat-preparation') || this.doc.URL.includes('cat-roadmap') || this.doc.URL.includes('cat-mock-test')) {
      this.showCoursePackages = false
    } else {
      this.showCoursePackages = true;
    }

    if (this.doc.URL.includes('dashboard') || this.doc.URL.includes('cat-preparation') || this.doc.URL.includes('cat-roadmap')) {
      this.setTidioVisibility(false);
    } else {
      this.setTidioVisibility(true);
    }

  }

  closeenquiry() {
    this.showEnquiryBtn = false
  }

  showbtn() {
    this.showEnquiryBtn = true

  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
        const script2 = this.renderer.createElement('script');
      script2.src = 'https://code.tidio.co/optn6elfrjsahihtiq1njkaczjgbndtw.js';
      script2.async = true;
      this.renderer.appendChild(document.body, script2);
      const script = this.renderer.createElement('script');
      script.src = 'https://media.iquanta.in/ui_images/js/katex.min.js';
      script.async = true;
      this.renderer.appendChild(document.body, script);
       const script1 = this.renderer.createElement('script');
      script1.src = 'https://media.iquanta.in/ui_images/js/vdocipher.js';
      script1.async = true;
      this.renderer.appendChild(document.body, script1);
      setTimeout(() => {
        if (this.doc.URL.includes('dashboard') || this.doc.URL.includes('cat-2025-new')) {
          this.setTidioVisibility(false);
        } else {
          this.setTidioVisibility(true);
        }
      }, 3000)
  }

    }


}


@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.html'
})

export class LeadFormDialog {
  stepVal: any = 1;
  userDetailsForm!: FormGroup;
  targetIIM: any;
  howPrepared: any;
  courseInterested: any;
  formSubmitted: boolean = false;
  constructor(public dialogRef: MatDialogRef<LeadFormDialog>, public formBuilder: FormBuilder,
    public coursesService: AppService, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public dashboardService: AppService, @Inject(DOCUMENT) public dom: any,
    public deviceService: DeviceDetectorService
  ) {
    this.userDetailsForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
      mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      currentstatus: ['', Validators.required],
    })
  }

  step1(val: any) {
    this.targetIIM = val;

  }

  gotolink(val: any) {
    window.open(val, '_blank')
  }

  step2(val: any) {
    this.seeYourself = val;

  }

  step3(val: any) {
    this.howPrepared = val;

  }

  step4(val: any) {
    this.courseInterested = val;

  }

  addInternalCRMLead1() {
    let medium: any;
    let source: any;
    let campaign: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
        if (item.includes('utm_source')) {
          source = item.split('=')[1]
        }
        if (item.includes('utm_campaign')) {
          campaign = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "name": this.userDetailsForm.value.name,
      "firstName": this.userDetailsForm.value.name,
      "phone": this.userDetailsForm.value.mobile,
      "email": this.userDetailsForm.value.email,
      "countryCode": 91,
      "source": "Website",
      "medium": "Popup",
      "campaign": this.dom.URL.includes('cat-roadmap') ? 'Facebook' : this.dom.URL.includes('cat-preparation') ? 'Google' : 'Personalized Counselling',
      "orgId": this.dom.URL.includes('/offline-center/jamshedpur') ? "68380db410fb67f12376090d" : "66dec57ce200bc89284602d6",
        "uid": this.dom.URL.includes('/offline-center/jamshedpur') ? "68380db510fb67f123760933" : '66dec57ce200bc89284602d6',
      "userId": 9999,
      "registrationDate": new Date().valueOf(),
      "pageLocation": this.dom.URL,
      "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
      "registrationDevice": this.deviceService.deviceType,
      "customFields": {
        "exam": 'CAT',
        "examCategory": 'MBA',
        "examTargetYear": this.userDetailsForm.value.currentstatus,
        "leadPriority": "Platinum",
        "q1": this.targetIIM ? this.targetIIM : '',
        "q2": this.seeYourself ? this.seeYourself : '',
        "q3": this.howPrepared ? this.howPrepared : ''
      },
      "ipAddress": this.sessionStorage.getItem('ipAddress'),
      courseInterestedIn: this.courseInterested ? this.courseInterested : '',
      dataSource: [
        {
          utmSource: source,
          utmMedium: medium,
          utmCampaign: campaign,
          utmAdContent: "",
          "source": "Website",
      "medium": "Popup",
      "campaign": this.dom.URL.includes('cat-roadmap') ? 'Facebook' : this.dom.URL.includes('cat-preparation') ? 'Google' : 'Personalized Counselling',
          adContent: "",
          "pageLocation": this.dom.URL,
          browser: this.deviceService.browser,
          browser_version: this.deviceService.browser_version,
          device: this.deviceService.device,
          deviceType: this.deviceService.deviceType,
          orientation: this.deviceService.orientation,
          os: this.deviceService.os,
          os_version: this.deviceService.os_version,
          platformId: this.deviceService['platformId'],
          ua: this.deviceService.ua,
          userAgent: this.deviceService.userAgent,
          "ipAddress": this.sessionStorage.getItem('ipAddress'),
          courseInterestedIn: this.courseInterested ? this.courseInterested : ''
        },
      ],
    }

    this.dashboardService.addCRMLead(reqObj).subscribe(res => {
      if (res.success) {

      } else {
      }
    }, err => {
      if (err.statusText == 'Unknown Error') {
        this.callBackLead(reqObj)
      }
    })
  }

  callBackLead(reqObj: any) {
    this.dashboardService.callbackLead(reqObj).subscribe(res => {

    })
  }

  leadId: any;
  seeYourself: any;

  nextStep() {
    if (this.stepVal == 1) {
      this.formSubmitted = false;
      if (this.userDetailsForm.valid) {
        let reqObj = {
          "name": this.userDetailsForm.value.name,
          "email": this.userDetailsForm.value.email,
          "phone": this.userDetailsForm.value.mobile,
          "currentStatus": this.userDetailsForm.value.currentstatus,
        }
        this.coursesService.saveUserLEadForm(reqObj).subscribe(res => {
          if (res.success) {
            this.leadId = res.data.batch;
            this.stepVal++;
            this.addInternalCRMLead1()
            // this.sessionStorage.setItem('leadObj', JSON.stringify(res.data.batch))
            // this.leadId['name'] = this.userDetailsForm.value.name;
            // this.leadId['email'] = this.userDetailsForm.value.email;
            // this.leadId['phone'] = this.userDetailsForm.value.mobile;
            // this.leadId['currentStatus'] = this.userDetailsForm.value.currentstatus;
            // this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            // this.stepVal++;
          }
        })
      } else {
        this.formSubmitted = true;

      }
    } else {
      if (this.stepVal == 2) {
        if (this.targetIIM) {
          let reqObj = {
            "targetIIM": this.targetIIM
          }
          this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res => {
            if (res.success) {
              this.leadId['targetIIM'] = this.targetIIM;
              this.stepVal++;
              // this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            }
          })
        }
      } else if (this.stepVal == 3) {
        if (this.seeYourself) {
          let reqObj = {
            "seeYourself": this.seeYourself
          }
          this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res => {
            if (res.success) {
              this.stepVal++;
              this.leadId['seeYourself'] = this.seeYourself;
              // this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            }
          })
        }
      } else if (this.stepVal == 4) {
        if (this.howPrepared) {
          let reqObj = {
            "howPrepared": this.howPrepared
          }
          this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res => {
            if (res.success) {
              this.stepVal++;
              this.leadId['howPrepared'] = this.howPrepared;
              // this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            }
          })
        }
      } else if (this.stepVal == 5) {
        if (this.courseInterested) {
          let reqObj = {
            "step4": this.courseInterested
          }
          this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res => {
            if (res.success) {
              this.leadSubmitted = true;
              this.leadId['step4'] = this.courseInterested;
              this.addInternalCRMLead1()
              //  this.dialogRef.close(res)
              this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
            }
          })
        }
      }
      // this.stepVal++;
    }
  }

  leadSubmitted: boolean = false;

  backStep() {
    this.stepVal--;

  }

  closeModal() {
    this.dialogRef.close()
  }

}